import {text} from './formatters.mjs';

/** Presentation helpers only: callers must pass events already authorized by the server. */
export function visibleEventMessage(event={}) {
 return [event.body,event.message,event.description].map(text).find(value=>typeof value==='string'&&value.trim()) || '';
}
export function visibleEventTime(event={}) {
 return [event.at,event.createdAt].find(value=>value!=null&&value!==''&&Number.isFinite(new Date(value).getTime())) ?? null;
}
export function latestVisibleDevelopment(events=[]) {
 return events.map((event,index)=>({message:visibleEventMessage(event),at:visibleEventTime(event),index}))
  .filter(event=>event.message)
  .sort((a,b)=>(b.at==null?-Infinity:new Date(b.at).getTime())-(a.at==null?-Infinity:new Date(a.at).getTime())||b.index-a.index)[0];
}
